import { render, staticRenderFns } from "./MobileHomePartner.vue?vue&type=template&id=9189f620&scoped=true"
import script from "./MobileHomePartner.vue?vue&type=script&lang=js"
export * from "./MobileHomePartner.vue?vue&type=script&lang=js"
import style0 from "./MobileHomePartner.vue?vue&type=style&index=0&id=9189f620&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9189f620",
  null
  
)

export default component.exports